export default __webpack_public_path__ + "static/media/background4.5a2db4e2.jpeg";